export const LOCALE = process.env.REACT_APP_LOCALE || 'ru';
export const OUTSTAFF = !!process.env.REACT_APP_OUTSTAFF;
export const LANDING_URL = process.env.REACT_APP_LANDING_URL || '';
